<div class="d-flex justify-content-between align-items-center p-2 list-element">
  {{file.name}} <mat-icon (click)="deleteFile()">delete</mat-icon>
</div>
